"use client"

import { createContext, useContext, type ReactNode } from "react"

const FlowRoutesContext = createContext(false)

export const FlowRoutesProvider = ({ enabled, children }: { enabled: boolean; children: ReactNode }) => <FlowRoutesContext value={enabled}>{children}</FlowRoutesContext>

export const useFlowRoutes = (): boolean => useContext(FlowRoutesContext)
